import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const TasksPageContent = lazy(() => import("./TasksPageContent"));

function TasksPageInternal() {
    return (
        <DefaultPage>
            <TasksPageContent />
        </DefaultPage>
    );
}

export const TasksPage = withAuthorization(
    getAuthorizationGuard(
        Role.OWNER,
        Role.ADMIN,
        Role.PLANNER,
        Role.EMPLOYEE,
        Role.TEMPORARY_WORKER,
        Role.SUBCONTRACTOR
    )
)(TasksPageInternal);
